// eslint-disable-next-line
export const COUPON_STATUS = {
    STATUS_NEW: 1, // 未领取
    STATUS_RECEIVED: 2, // 已领取
    STATUS_FAILED: 3, // 领取失败
    STATUS_USED: 4, // 已使用
    STATUS_EXPIRED: 5, // 已过期(未使用)
    STATUS_LOCKED_NEW: 6, // 未领取(但是目前还不可领取,有些条件不满足,比如分享/签到)
    STATUS_RECEIVE_EXPIRED: 7, // 已过期(未领取)
};

export const PAGE_C_ID = 'c_waimai_8nv7fbi8';
